import { render, staticRenderFns } from "./widget-stat.vue?vue&type=template&id=66dae964&"
import script from "./widget-stat.vue?vue&type=script&lang=js&"
export * from "./widget-stat.vue?vue&type=script&lang=js&"
import style0 from "./widget-stat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports